import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { PlanService } from "../../Services";
import Loader from "../../Components/Loader";
import { FiBox, FiStar, FiCheckSquare, FiPlusCircle, FiTrash2 } from "react-icons/fi";

export const EditPlan = (props) => {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [availableAddons, setAvailableAddons] = useState([]);
  
  const stateData = history.location.state || {};
  
  const [formData, setFormData] = useState({
    id: stateData._id || "",
    name: stateData.name || "",
    type_name: stateData.type_name || "",
    description: stateData.description || "",
    monthly_price: stateData.monthly_price || 0,
    yearly_price: stateData.yearly_price || 0,
    badge: stateData.badge || "",
    popular: stateData.popular || false,
    credits: stateData.credits || 0,
    max_users: stateData.max_users !== undefined ? stateData.max_users : -1,
    features: stateData.features || [],
    addons: stateData.addons ? stateData.addons.map(a => a._id || a) : []
  });

  const [newFeature, setNewFeature] = useState("");

  useEffect(() => {
    PlanService.getAddons().then(res => {
      if (res.status) {
        setAvailableAddons(res.data);
      }
    });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleAddFeature = () => {
    if (newFeature.trim()) {
      setFormData(prev => ({ ...prev, features: [...prev.features, newFeature.trim()] }));
      setNewFeature("");
    }
  };

  const handleRemoveFeature = (index) => {
    setFormData(prev => {
      const newFeatures = [...prev.features];
      newFeatures.splice(index, 1);
      return { ...prev, features: newFeatures };
    });
  };

  const handleAddonToggle = (addonId) => {
    setFormData(prev => {
      const newAddons = [...prev.addons];
      if (newAddons.includes(addonId)) {
        return { ...prev, addons: newAddons.filter(id => id !== addonId) };
      } else {
        newAddons.push(addonId);
        return { ...prev, addons: newAddons };
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    PlanService.updatePlan(formData).then((res) => {
      setLoader(false);
      if (res.status) {
        history.push("/plan-list");
      } else {
        alert(res.message || "Failed to update plan");
      }
    }).catch((err) => {
      setLoader(false);
      alert("Error updating plan");
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <form onSubmit={handleSubmit}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="card-title mb-0" style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>Edit Plan</h4>
            <div>
              <button type="button" className="btn btn-outline-secondary me-2" onClick={() => history.push("/plan-list")}>Cancel</button>
              <button type="submit" className="btn btn-primary shadow-sm" style={{ fontWeight: '600' }}>Update Plan</button>
            </div>
          </div>

          <div className="row">
            {/* Left Column */}
            <div className="col-lg-8">
              {/* Basic Details Card */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                  <h5 className="mb-0 text-primary d-flex align-items-center">
                    <FiBox className="me-2" /> Basic Details & Pricing
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Plan Name</label>
                      <input type="text" className="form-control bg-light border-0" name="name" value={formData.name} onChange={handleChange} placeholder="e.g. Growth Plan" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Type Name</label>
                      <input type="text" className="form-control bg-light border-0" name="type_name" value={formData.type_name} onChange={handleChange} placeholder="e.g. Subscription" />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label text-muted fw-bold">Description</label>
                      <textarea className="form-control bg-light border-0" name="description" rows="2" value={formData.description} onChange={handleChange} placeholder="Good for..."></textarea>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Monthly Price</label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-0">$</span>
                        <input type="number" className="form-control bg-light border-0" name="monthly_price" value={formData.monthly_price} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Yearly Price</label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-0">$</span>
                        <input type="number" className="form-control bg-light border-0" name="yearly_price" value={formData.yearly_price} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Credits Included</label>
                      <input type="number" className="form-control bg-light border-0" name="credits" value={formData.credits} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted fw-bold">Max Users (Employees)</label>
                      <input type="number" className="form-control bg-light border-0" name="max_users" value={formData.max_users !== undefined ? formData.max_users : -1} onChange={handleChange} required />
                      <small className="text-muted">Enter -1 for Unlimited</small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Core Features Card */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                  <h5 className="mb-0 text-primary d-flex align-items-center">
                    <FiCheckSquare className="me-2" /> Dynamic Features
                  </h5>
                </div>
                <div className="card-body">
                  <div className="d-flex mb-3">
                    <input type="text" className="form-control me-2" placeholder="e.g. 5,000 API Calls / month" value={newFeature} onChange={(e) => setNewFeature(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAddFeature())} />
                    <button type="button" className="btn btn-primary" onClick={handleAddFeature}>Add Feature</button>
                  </div>
                  <ul className="list-group list-group-flush">
                    {formData.features.map((feature, index) => (
                      <li key={index} className="list-group-item d-flex justify-content-between align-items-center px-0">
                        <span><FiCheckSquare className="text-success me-2" /> {feature}</span>
                        <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveFeature(index)}>
                          <FiTrash2 />
                        </button>
                      </li>
                    ))}
                    {formData.features.length === 0 && <li className="list-group-item text-muted px-0 border-0">No features added yet.</li>}
                  </ul>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-4">
              
              {/* Display & Presentation Card */}
              <div className="card shadow-sm border-0 mb-4 bg-primary text-white">
                <div className="card-header border-bottom-0 pt-4 pb-0 bg-transparent">
                  <h5 className="mb-0 text-white d-flex align-items-center">
                    <FiStar className="me-2" /> Display (SaaS Portal)
                  </h5>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Badge Text</label>
                    <input type="text" className="form-control border-0" name="badge" placeholder="e.g. Popular Choice" value={formData.badge} onChange={handleChange} style={{ background: 'rgba(255,255,255,0.2)', color: '#fff' }} />
                  </div>
                  <div className="form-check form-switch form-switch-md mt-3" dir="ltr">
                    <input type="checkbox" className="form-check-input" name="popular" checked={formData.popular} onChange={handleChange} />
                    <label className="form-check-label ms-2 fw-bold text-white">Highlight as Popular?</label>
                  </div>
                </div>
              </div>

              {/* Addons Selection Card */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                  <h5 className="mb-0 text-primary d-flex align-items-center">
                    <FiPlusCircle className="me-2" /> Link Addons
                  </h5>
                </div>
                <div className="card-body">
                  {availableAddons.length === 0 ? (
                    <p className="text-muted small">No addons available. Create an addon first.</p>
                  ) : (
                    <div className="list-group">
                      {availableAddons.map(addon => (
                        <label key={addon._id} className="list-group-item d-flex gap-2 align-items-center">
                          <input className="form-check-input flex-shrink-0" type="checkbox" checked={formData.addons.includes(addon._id)} onChange={() => handleAddonToggle(addon._id)} />
                          <span>
                            {addon.name} <br/>
                            <small className="text-muted">${addon.price}/{addon.duration === "Monthly" ? "mo" : "yr"}</small>
                          </span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        </form>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
